
// idle.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { Constant } from '../configs/constant';

@Injectable({ providedIn: 'root' })
export class IdleService implements OnDestroy {
  private timeout = Constant.SESSTION_EXPIRED * 1000; // 10 phút
  private timer: any;
  private onTimeoutCallback: Function | null = null;
  
  private events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
  private boundResetTimer = this.resetTimer.bind(this);

  constructor() {}

  startWatching(onTimeout: Function) {
    this.onTimeoutCallback = onTimeout;
    
    // Đăng ký event listeners
    this.startListeners();
    
    // Bắt đầu timer
    this.resetTimer();
  }

  stopWatching() {
    this.stopListeners();
    this.clearTimer();
  }

  private startListeners() {
    this.events.forEach(event => {
      document.addEventListener(event, this.boundResetTimer, true);
    });
  }

  private stopListeners() {
    this.events.forEach(event => {
      document.removeEventListener(event, this.boundResetTimer, true);
    });
  }

  private resetTimer() {
    this.clearTimer();
    
    this.timer = setTimeout(() => {
      if (this.onTimeoutCallback) {
        this.onTimeoutCallback();
      }
    }, this.timeout);
  }

  private clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  ngOnDestroy() {
    this.stopWatching();
  }

  // Phương thức để thay đổi timeout nếu cần
  setTimeout(newTimeout: number) {
    this.timeout = newTimeout * 1000;
    this.resetTimer();
  }
}